import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import {ExamsService} from '../exams.service';
import { LightboxConfig,Lightbox,LightboxEvent, LIGHTBOX_EVENT } from 'ngx-lightbox';
import {GalleryService} from '../gallery.service';
import { Subscription } from 'rxjs';
import { UntypedFormBuilder, FormControl } from '@angular/forms';
import { LoginService } from '../login.service';
import { DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
    selector: 'app-gallery',
    templateUrl: './gallery.component.html',
    styleUrls: ['./gallery.component.scss'],
    standalone: false
})
export class GalleryComponent implements OnInit,OnDestroy {
  src:string;
  imgct:number;
  clipct:number;
  fullct: number;
  pdfct: number;
  timelinect: number;
  dwonloadImageCt: number;
  view = 'Groups';
  _albums: any[] = [];
  _clips: any[] = [];
  _fulls: any[] = [];
  _timeline: any[] = [];
  _pdfs: any[] = [];
  currentclip="";
  showVid=false;
  @Input('forprint') forPrint: boolean;
  @Input('inbox') inbox: number;
  @Output() closed = new EventEmitter<null>();
  private _subscription: Subscription;
  private meadiaSub: Subscription;
  private dicomSub: Subscription;
  private dicomPollInterval: ReturnType<typeof setInterval> | null = null;
  private readonly DICOM_POLL_MS = 30_000;
  private dicomMediaLoaded = false;
  private dicomLoadingTimer: ReturnType<typeof setTimeout> | null = null;
  dicomMediaLoading = false;
  invalidi = '';
  download=false;
  image;
  isPDFLoading = false;
  pdfToShow:SafeResourceUrl=null;
  advLoading = false;

  constructor(public ls:LoginService,public es: ExamsService,private lbox: Lightbox,private config: LightboxConfig, public gs: GalleryService,private _lightboxEvent: LightboxEvent, public fb:UntypedFormBuilder,private sanitizer:DomSanitizer, private cdr: ChangeDetectorRef) { 
    this.config.showImageNumberLabel=true;
    this.config.fadeDuration=0.3;
    try{
      this.close();
    }
    catch{}
    this.resetImage();
  }

  resetImage(){
    this.image = this.fb.group({
      AutoIndex:[''],
      text:['']
    })
  }

  ngOnInit() {
    this.src="";
    this.imgct=0;
    this.clipct=0;
    this.fullct=0;
    this.timelinect=0;
    this.pdfct = 0;
    this.dwonloadImageCt=0;
    if(this.gs.HasDemos){
      switch(this.es.ExamType){
        case 'NT':
          this.src='NT';
          this.imgct=7;
          break;
        case 'Early':
          this.src='Early';
          this.imgct=31;
          this.clipct=5;
          break;
        case 'Late':
          this.src='Late';
          this.imgct=23;
          this.clipct=5;
      }

      for (let i = 1; i <= this.imgct; i++) {
        const src = '../../assets/demo/'+this.src+'/'+i+'.jpg'
        const caption = 'Image ' + i;
        const thumb = '../../assets/demo/'+this.src+'/thumbs/'+i+'.jpg'
        const album = {
          src: src,
          //caption: caption,
          thumb: thumb
        };
  
        this._albums.push(album);
      }

      for (let i = 1; i <= this.clipct; i++) {
        const src = '../../assets/demo/'+this.src+'/clips/'+i+'.mp4'
        const caption = 'Image ' + i;
        const thumb = '../../assets/demo/'+this.src+'/clips/thumbs/'+i+'.jpg'
        const album = {
          src: src,
          //caption: caption,
          thumb: thumb
        };
  
        this._clips.push(album);
      }
    }
    else{
      this.loadGallery();
      this.loadDicomMedia();
    }

   
    if(! this.es.isClosed){
      this.meadiaSub = this.es.mediaArrived$.subscribe((mtype)=>{
        if(mtype != 'html')
          this.loadGallery();
      });
    }
    this.dicomSub = this.es.dicomReady$.subscribe(() => {
      this.cdr.detectChanges();
      if (this.es.dicomStudyUID) this.stopDicomPoll();
    });
    this.startDicomPoll();

  }

  ngOnDestroy(): void {
    if(this.meadiaSub)
      this.meadiaSub.unsubscribe();
    if(this.dicomSub)
      this.dicomSub.unsubscribe();
    if(this.dicomLoadingTimer)
      clearTimeout(this.dicomLoadingTimer);
    this.stopDicomPoll();
  }

  private startDicomPoll() {
    if (this.es.dicomStudyUID) return;
    this.es.checkDicom();
    this.dicomPollInterval = setInterval(() => {
      if (this.es.dicomStudyUID) { this.stopDicomPoll(); return; }
      this.es.checkDicom();
    }, this.DICOM_POLL_MS);
  }

  private stopDicomPoll() {
    if (this.dicomPollInterval) {
      clearInterval(this.dicomPollInterval);
      this.dicomPollInterval = null;
    }
  }

  loadGallery(){
    this.gs.getGallery(()=>{
      for (let i = 0; i < this.gs.Images.length; i++) {
        const src = '/api/getmedia/'+this.gs.Images[i][0]+'/n';
        const thumb = `/api/getmedia/${this.gs.Images[i][0]}/y`;
        const text = this.gs.Images[i][2]
        const album = {
          src: src,
          //caption: caption,
          thumb: thumb,
          text:  text
        };
  
        this._albums.push(album);
      }
      this.imgct = this.gs.Images.length;
      this.dwonloadImageCt = this.gs.imageSelection.value.filter((i) => i === true).length;
      this.gs.imageSelection.valueChanges.subscribe((res) => {
        this.dwonloadImageCt =res.filter((i) => i === true).length
      })

      for (let i = 0; i < this.gs.Clips.length; i++) {
        const src = '/api/getmedia/'+this.gs.Clips[i]+'/n';
        const caption = 'Image ' + i;
        const thumb =  '/api/getmedia/'+this.gs.Clips[i]+'/y';
        const album = {
          src: src,
          //caption: caption,
          thumb: thumb
        };
  
        this._clips.push(album);
      }
      this.clipct = this.gs.Clips.length;


      for (let i = 0; i < this.gs.Fulls.length; i++) {
        const src = '/api/getmedia/'+this.gs.Fulls[i]+'/n';
        const caption = 'Image ' + i;
        const thumb =  '/api/getmedia/'+this.gs.Fulls[i]+'/y';
        const album = {
          src: src,
          //caption: caption,
          thumb: thumb
        };
  
        this._fulls.push(album);
      }
      
      this.fullct = this.gs.Fulls.length;
      this.pdfct = this.gs.PDFs.length;
      for (let i = 0; i < this.gs.PDFs.length; i++) {
        const src = '/api/getmedia/'+this.gs.PDFs[i]+'/n';
        const thumb =  '/api/getmedia/'+this.gs.PDFs[i]+'/y';
        const album = {
          src: src,
          thumb: thumb
        };
  
        this._pdfs.push(album);
      }

      for (let i = 0; i < this.gs.Timeline.length; i++) {
        if( Array.isArray(this.gs.Timeline[i])){
          const src = '/api/getmedia/'+this.gs.Timeline[i][0]+'/n';
          const thumb = `/api/getmedia/${this.gs.Timeline[i][0]}/y`;
          const text = this.gs.Timeline[i][2]
          const album = {
            src: src,
            //caption: caption,
            thumb: thumb,
            text:  text
          };
    
          this._timeline.push(album);
        }else{

          const src = '/api/getmedia/'+this.gs.Timeline[i]+'/n';
          const caption = 'Image ' + i;
          const thumb =  '/api/getmedia/'+this.gs.Timeline[i]+'/y';
          const album = {
            src: src,
            //caption: caption,
            thumb: thumb
          };
          this._timeline.push(album);
        }
        
      }
      this.timelinect = this.gs.Timeline.length;
    }, this.inbox);
  }


  open(index: number): void {
    // open lightbox
    // this.lbox.open(this._albums, index);
    //this.lbox.close();
    if(this.view =='Timeline'){
      this.lbox.open(this._timeline, index);
    }else{
      this.lbox.open(this._albums, index);
    }
    this.gs.currentImg = index;
    this.gs.isOpen=true;
    this.gs.mode='img';
    this._subscription = this._lightboxEvent.lightboxEvent$
      .subscribe((event) => {
        if (event["id"] === LIGHTBOX_EVENT.CLOSE) {
          // event CLOSED is fired
          this.gs.isOpen=false;
          this._subscription.unsubscribe();
        }
     
        if (event["id"] === LIGHTBOX_EVENT.OPEN) {
          // event OPEN is fired
        }
     
        if (event["id"] === LIGHTBOX_EVENT.CHANGE_PAGE) {
          // event change page is fired
          this.gs.currentImg = event["data"]; // -> image index that lightbox is switched to
        }
      });
  }

  openClip(index: number, full=false): void {
    if(this.view == 'Timeline'){
      this.currentclip = this._timeline[index].src;
      this.gs.mode= 'clip';

    }else{ 
      this.currentclip= full ? this._fulls[index].src : this._clips[index].src;
      this.gs.mode= full ? 'full':'clip';
    }
    this.showVid=true;
    this.gs.isOpen=true;
    this.gs.currentImg=index;
  }

  openPDF(index:number){
    const pdf: any = this._pdfs[index];
    const req = pdf?.dicom
      ? this.gs.getDicomPdf(pdf.study, pdf.series, pdf.instance)
      : this.gs.getPDF(index);
    req.subscribe((data)=>{
      this.gs.isOpen=true;
      this.gs.mode='pdf';
      this.gs.currentPdf=index
      this.isPDFLoading = false;
      let file = new Blob([data], {type: 'application/pdf'});
      this.pdfToShow = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(file));
    },(err)=>{
      console.log(err);
    })
  }

  // Fetch DICOM images/PDFs for this exam and append to the legacy gallery
  // (imgct/pdfct increase — legacy media is never replaced). Fetched once per
  // exam open; skipped entirely server-side for clinics without a DicomStoreId.
  loadDicomMedia() {
    if (this.dicomMediaLoaded) return;
    this.dicomMediaLoaded = true;
    // Debounce the spinner: unconfigured clinics resolve near-instantly (one local
    // SQL check, no GCP call) — only show it once the request has been pending long
    // enough that it's a real fetch, so legacy clinics never see a flash.
    this.dicomLoadingTimer = setTimeout(() => { this.dicomMediaLoading = true; }, 200);
    this.gs.getDicomMedia().subscribe({
      next: (data) => {
        if (this.dicomLoadingTimer) clearTimeout(this.dicomLoadingTimer);
        this.dicomMediaLoading = false;
        for (const img of data?.images || []) {
          this._albums.push({
            src: `/api/dicom/instance-preview/${img.studyUID}/${img.seriesUID}/${img.instanceUID}`,
            thumb: `/api/dicom/instance-preview/${img.studyUID}/${img.seriesUID}/${img.instanceUID}`,
            dicom: true,
            dicomUid: img.instanceUID,
            study: img.studyUID,
            series: img.seriesUID,
            printChecked: false,
          } as any);
        }
        this.imgct = this._albums.length;

        for (const pdf of data?.pdfs || []) {
          this._pdfs.push({
            src: `/api/dicom/instance-pdf/${pdf.studyUID}/${pdf.seriesUID}/${pdf.instanceUID}`,
            thumb: '../../assets/icons/fileb.svg',
            dicom: true,
            study: pdf.studyUID,
            series: pdf.seriesUID,
            instance: pdf.instanceUID,
          } as any);
        }
        this.pdfct = this._pdfs.length;

        if (data?.images?.length) this.loadDicomPrintSelections();
      },
      error: () => {
        if (this.dicomLoadingTimer) clearTimeout(this.dicomLoadingTimer);
        this.dicomMediaLoading = false;
        /* DICOM unavailable or clinic not configured — legacy gallery unaffected */
      },
    });
  }

  private loadDicomPrintSelections() {
    this.gs.getDicomSelections().subscribe({
      next: (data) => {
        const printed = new Set(
          (data?.selections || []).filter((s: any) => s.print == 1 || s.print === true).map((s: any) => s.uid)
        );
        for (const a of this._albums as any[]) {
          if (a.dicom) a.printChecked = printed.has(a.dicomUid);
        }
      },
      error: () => {},
    });
  }

  // Select All / Deselect All only affects DICOM checkboxes in the print picker —
  // DICOM images don't participate in the download-select flow (gs.showSelect).
  selectAllImages(select: boolean) {
    this.gs.selectAll(select);
    if (this.forPrint) {
      for (const a of this._albums as any[]) {
        if (a.dicom) {
          a.printChecked = select;
          this.gs.saveDicom(a.dicomUid, select, a.study, a.series);
        }
      }
    }
  }

  close(): void {
    // close lightbox programmatically
    this.lbox.close();
    this.gs.isOpen=false;
    this.gs.showSelect =false;
  }

  assign(){
    this.gs.assignInbox(this.inbox);
    this.closed.emit();
  }

  checkArray(item){
    return Array.isArray(item)
  }

  openInADV() {
    const studyUID = this.es.dicomStudyUID;
    const clinicId = this.es.dicomClinicId;
    if (!studyUID || !clinicId) return;
    window.open(`https://viewer.beta.artisansonics.com/study/${studyUID}?clinicId=${encodeURIComponent(clinicId)}`, '_blank');
  }

}
